var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"id":_vm.id},on:{"enter":_vm.updateRoute}},[_c('PageSection',{attrs:{"title":"portfolio.works","subtitle":"Latest agency & side projects"}},[_c('TableList',_vm._l((_vm.works),function(work){return _c('SummaryTable',{key:work.id,attrs:{"caption":"project","data":work,"styles":['brackets']}})}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0726a9bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/assets/js/containers/Portfolio/index.vue
// module id = tErj
// module chunks = 2